import { useEffect, useState } from 'react';

import { useCheckListContext } from '../context/CheckListProvider';

export const useStepsStatus = () => {
  const [stepsDone, setStepsDone] = useState(0);
  const { answers, currentStep } = useCheckListContext();
  const allSteps = Object.keys(answers).length;

  useEffect(() => {
    setStepsDone(
      Object.values(answers).filter((answer) => answer !== '').length
    );
  }, [answers]);

  return {
    stepsDone,
    allSteps,
    currentStep
  };
};
